var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row col field-list-item2"},_vm._l((_vm.texts),function(text,index){return _c('div',{key:`${index}`,staticClass:"col",attrs:{"title":text}},[_vm._v(" "+_vm._s(text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }